"use client";
import { HeaderBlock, ThemeBlockPropertyCustom } from "@/components/cms/cms-shared-graphql-config/type";
import BleedBanner from "@/components/cms/component/bleedBanner";
import { useRootExperience } from "@/store/store";
import { HeaderContext } from "@/utils/providers/HeaderProvider";
import { HeaderCms } from "@nrldigitaltechnology/ui-community";
import { ServiceButtons } from "@nrldigitaltechnology/ui-community/dist/components/HeaderCms/types";
import React, { useContext, useEffect, useMemo, useState } from "react";
import ImageWithFallback from "./ImageFallBack";
import { getNationalId } from "@/utils/utilities";
import { get } from "http";

// type HeaderMenuOptionsProps = {
//   menuOptions: { name: string; url: string }[];
//   subMenuOptions: Record<string, { name: string; url: string }[]>;
//   serviceButtons?: ServiceButtons[];
// };

// type HeaderLayoutProps = {
// };

export const HeaderLayoutCompetitions = () => {
  const headerRef = useContext(HeaderContext);
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

 
  const nationalId = getNationalId(); 

    const headerLogo =  nationalId === 32 ? "/assets/logo/playRugbyLeagueLogo.svg" : nationalId === 31 ? "/assets/logo/tfa_logo.png" : "";


   const { setExperience } = useRootExperience();

  useEffect(() => {
    const heroImage =  nationalId === 32 ? "/assets/common/poster.jpg" : nationalId === 31 ? "/assets/common/tfa_poster.jpeg" : "";
    setExperience({heroImage});
  },[])
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 120) {
        setShowHeader(false);
      } else {
        setShowHeader(true);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);


  return (
    <>
      <div
      data-an-module="header"
        ref={headerRef}
        className={`w-full transition-transform duration-300 z-50 ${showHeader
          ? "translate-y-0 pointer-events-auto"
          : "-translate-y-full pointer-events-none"
          }`}
      >
        <div className="bg-black h-[72px] px-4 flex items-center">
          <img className="w-auto max-h-[50px]" src={headerLogo || ""} alt="logo"  />
          {
            nationalId === 31 && (
              <p className="text-lg font-bold text-white ml-4">{"TOUCH FOOTBALL AUSTRALIA"}</p>
            )
          }
        </div>
      </div>
    </>
  );
};

export const menuOptions = [
  { name: "play", url: "play" },
  { name: "assist", url: "assist" },
  { name: "learn", url: "learn" },
  { name: "competitions" },
  { name: "coach", url: "coach" },
  { name: "safety", url: "safety" },
  { name: "shop", url: "shop" },
];

export const subMenuOptions = {
  play: [
    { name: "club rugby league", url: "club-rugby-league" },
    { name: "rewards", url: "rewards" },
    { name: "wheelchair rugby league", url: "wheelchair-rugby-league" },
    { name: "league stars", url: "league-stars" },
    { name: "little league stars", url: "little-league-stars" },
    { name: "school holiday clinics", url: "school-holiday-clinics" },
    { name: "child safety", url: "child-safety" },
  ],
  competitions: [
    { name: "club rugby league", url: "club-rugby-league" },
    { name: "rewards", url: "rewards" },
    { name: "wheelchair rugby league", url: "wheelchair-rugby-league" },
    { name: "league stars", url: "league-stars" },
    { name: "little league stars", url: "little-league-stars" },
    { name: "school holiday clinics", url: "school-holiday-clinics" },
    { name: "child safety", url: "child-safety" },
  ],
};

export const serviceButtons: ServiceButtons[] = [
  { name: "register", url: "register", variant: "primary" },
  { name: "log in", variant: "secondary" },
];
